import React, { ReactElement } from 'react'

import {
  Col,
  FormRow,
} from '../../../../../../../1stlog-ui/src/components/Bootstrap'
import { FieldPrefix } from '../../../../../../../1stlog-ui/src/components/Field'
import FieldArrayControl from '../../../../../../../1stlog-ui/src/components/FieldArrayControl'
import { AdditionalEmail } from './AdditionalEmail'
import { AdditionalPhone } from './AdditionalPhone'

type AdditionalContactsProps = {
  showPhone: boolean
  showEmail: boolean
  hasPhone: boolean
  hasEmail: boolean
}

export const AdditionalContacts = (
  props: AdditionalContactsProps,
): ReactElement => {
  const { showPhone, showEmail, hasPhone, hasEmail } = props

  return (
    <>
      <FormRow>
        {showPhone && (
          <Col md={6} lg={6}>
            <FieldPrefix prefix="" overwritePrefix>
              <FieldArrayControl
                flush
                innerStyle={{ margin: '0 0 -12px 0' }}
                name="clientNotificationsAdditionalPhones"
                FieldComponent={AdditionalPhone}
                newElement={{ phone: '' }}
                addText={i18n.t(
                  'additional_phone_number',
                  'Weitere Telefonnummer',
                )}
                additionalProps={{}}
              />
            </FieldPrefix>
          </Col>
        )}
        {showEmail && (
          <Col md={6} lg={6}>
            <FieldPrefix prefix="" overwritePrefix>
              <FieldArrayControl
                flush
                innerStyle={{ margin: '0 0 -12px 0' }}
                name="clientNotificationsAdditionalEmails"
                FieldComponent={AdditionalEmail}
                newElement={{ email: '' }}
                addText={i18n.t('additional_email', 'Weitere E-Mail')}
                additionalProps={{}}
              />
            </FieldPrefix>
          </Col>
        )}
      </FormRow>
    </>
  )
}
